export default "__VITE_PUBLIC_ASSET__6a4eed70__"